// extracted by mini-css-extract-plugin
module.exports = {"container":"Cannon-module--container--1X2CR","img":"Cannon-module--img--2iaCT","pulse":"Cannon-module--pulse--2iEiv"};